import styled, { css } from 'styled-components';

import { getPurpurColor, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

type SkeletonProps = {
    $height: number;
    $heightMobile: number;
};

export const Skeleton = styled.div<SkeletonProps>`
    background: ${getPurpurColor('functionalWhite')};

    ${({ $heightMobile, $height }) => css`
        height: ${$heightMobile}px;

        ${purpurMedia('lg')`
            height: ${$height}px;
        `}
    `};
`;
